export default "__VITE_ASSET__CbAIfsFa__"